import { render } from "./AppSearch.vue?vue&type=template&id=293a104b&lang=pug"
import script from "./AppSearch.vue?vue&type=script&lang=js"
export * from "./AppSearch.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\projects\\phpstorm\\amerika\\newjobs4you.news\\public_html\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__